import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useEffect, useRef } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { authStatus } = useAuthenticator((ctx) => [ctx.authStatus]);
  const hasShownToast = useRef(false);

  const hasSessionTokens = () => !!sessionStorage.getItem("access_token");
  const hasLocalIdentity = () => document.cookie.includes("X-Local-Identity=");
  const isAuthenticated = authStatus === "authenticated" || hasSessionTokens() || hasLocalIdentity();

  useEffect(() => {
    if (authStatus !== "configuring" && !isAuthenticated && !hasShownToast.current) {
      hasShownToast.current = true;
      toast.error("Please log in to access this page.");
    }
  }, [authStatus, isAuthenticated]);

  if (authStatus === "configuring") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
